import { css } from '@emotion/react';
import COLORS from 'shared/styles/colors';
import theme from 'shared/styles/themes';

export default css({
  '&.brief-module-content-input': {
    marginTop: theme.space[4],
  },
  '.brief-module-content-input': {
    '&__wrapper': {
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    '&__thumbnail': {
      maxHeight: '50px',
      marginRight: theme.space[3],
    },
    '&__file-name': {
      marginBottom: 0,
    },
    '&__file': {
      alignItems: 'center',
    },
    '&__remove': {
      backgroundColor: COLORS.NEUTRAL100,
      borderRadius: '5px',
    },
  },
});
